<template>
  <div class="h-100">
    <div class="content-page p-3 pb-5 h-100">
      <b-row class="h-5">
        <b-col cols="12">
          <S040000Menu
            :t="t"
            :dictEnum="dictEnum"
            :isLeaveRecordVisible="
              hasRight('AlwRead', Settings.MenuID.StaffLeaveRecord)
            "
            :isStaffAttendanceVisible="
              hasRight('AlwRead', Settings.MenuID.StaffAttendance)
            "
            :isMonthlyVisible="
              hasRight('AlwRead', Settings.MenuID.MonthlyLeaveBalance)
            "
            :isOutdoorVisible="
              hasRight('AlwRead', Settings.MenuID.OutdoorWorkAllowance)
            "
            :isTaxReturnVisible="hasRight('AlwRead', Settings.MenuID.TaxReturn)"
          />
        </b-col>
      </b-row>

      <b-row class="h-10 justify-content-between" align-v="center">
        <b-col cols="2" class="col2-width">
          <div>
            <date-picker
              :placeholder="this.t.t(dictEnum.LBL_From)"
              v-model="DateFrom"
              :lang="lang"
              type="date"
              format="YYYY-MM-DD"
              v-bind:editable="false"
              v-bind:clearable="false"
              @change="getStaffList()"
            ></date-picker>
          </div>
        </b-col>
        <b-col cols="2" class="col2-width">
          <div>
            <date-picker
              :placeholder="this.t.t(dictEnum.LBL_To)"
              v-model="DateTo"
              :not-before="DateFrom"
              :lang="lang"
              type="date"
              format="YYYY-MM-DD"
              v-bind:editable="false"
              v-bind:clearable="false"
              @change="getStaffList()"
            ></date-picker>
          </div>
        </b-col>
        <b-col cols="2" class="col2-width"  v-if="CompanyHide">
          <b-form-select size="sm" v-model="selectedComp" @change="changeComp">
            <option value selected>
              --- {{ this.t.t(dictEnum.LBL_Company) }} ---
            </option>
            <option
              v-for="(comp, index) in compList"
              :key="index"
              :value="comp.CompCode"
            >
              {{ user.Lang == "EN" ? comp.EName : comp.CName }}
            </option>
          </b-form-select>
        </b-col>
        <b-col cols="2" >
          <!-- <b-form-select v-model="selectedStaff" class="form-control" size="sm">
            <option value="" selected>
              {{ this.t.t(dictEnum.LBL_SelectAll) }}
            </option>
            <option
              v-for="option in StaffList"
              v-bind:key="option.StaffID"
              v-bind:value="option.StaffID"
            >
              {{
                user.Lang == "EN"
                  ? `${option.EngName} ${option.EngLastName}`
                  : `${option.ChiLastName}${option.ChiName}`
              }}
            </option>
          </b-form-select> -->
          <div class="d-flex align-items-center input-mb-0">
            <v-text-field
              :readonly="true"
              style="margin-top: -12px"
              class="form-input"
              name="staff"
              v-validate="{
                required: true
              }"
              :placeholder="'--- ' + this.t.t(dictEnum.LBL_Staff) + ' ---'"
              v-model="selectedStaff"
            ></v-text-field>
            <button
              type="button"
              class="btn btn-transparent p-1"
              :disabled="false"
              v-on:click="OnStaffBtnClick()"
            >
              <img src="../../../static/images/search.png" class="w-14" />
            </button>
          </div>
        </b-col>
        <b-col cols="4" align-self="center" class="text-right w-100 btn-scroll" style="flex: 0 0  36.3333333333%;
    max-width: 36.3333333333%;">
          <button class="btn btn-info" @click="syncFromMizar">
            {{ this.t.t(dictEnum.MENU_SyncFromMizar) }}
          </button>
          <FileReader
            :onlyText="true"
            v-if="hasRight(Settings.Permission.Import)"
            @load="importData"
            accept=".txt,.xlsx,.xls"
            :btnType="'btn-success'"
            :buttonText="
              this.t.t(dictEnum.LBL_Import) +
                this.t.t(dictEnum.LBL_CheckIn) +
                this.t.t(dictEnum.LBL_Record)
            "
          ></FileReader>
          <button
            class="btn btn-primary"
            @click="updateTimeCard"
            v-if="hasRight(Settings.Permission.Change)"
          >
            {{ this.t.t(dictEnum.LBL_UpdateTimeCard) }}
          </button>
          <button class="btn btn-info" @click="search">
            {{ this.t.t(dictEnum.LBL_Filter) }}
          </button>
          <FileReader
            :onlyText="true"
            v-if="hasRight(Settings.Permission.Import)"
            id="excelFileReader"
            @load="importData"
            @loadExcel="importExcelData"
            accept=".txt,.xlsx,.xls"
            :btnType="'btn-primary'"
            :buttonText="
              this.t.t(dictEnum.LBL_Import) +
                'Excel' +
                this.t.t(dictEnum.LBL_Record)
            "
          ></FileReader>
          <download-excel
            class="btn btn-primary"
            :fetch="ExportTableData"
            v-if="hasRight(Settings.Permission.Export)"
            :fields="columnsexport"
            type="xls"
            name="staffleaverecord.xls"
            :meta="[{ key: 'charset', value: 'utf-8' }]"
            >{{ this.t.t(dictEnum.BTN_Export) }}
          </download-excel>
        </b-col>
      </b-row>
      <!-- <b-row no-gutters class="d-flex justify-content-end">
        <b-col cols="1">
          <b-form-checkbox
            class="switchChk"
            switch
            v-model="switchMode"
            @change="changeMode"
          >
            {{
              switchMode
                ? t.t(dictEnum.LBL_ActClock)
                : t.t(dictEnum.LBL_CntClock)
            }}
          </b-form-checkbox>
        </b-col>
      </b-row> -->

      <b-row class="h-85">
        <b-col cols="12" class="h-100">
          <div class="tab-content bg-white h-100">
            <div v-if="switchMode" class="h-100">
              <div class="tab-pane active table-responsive color-table h-90">
                <v-data-table
                  disable-sort
                  :headers="activeTable.headers"
                  :items="activeTable.datas"
                  :page.sync="page"
                  :items-per-page="itemsPerPage"
                  hide-default-footer
                  class="elevation-1 tableRecord"
                  @page-count="pageCount = $event"
                >
                  <template v-slot:[`header.WorkHours`]="{ header }">
                    <div class="text-right">
                      {{ header.text }}
                    </div>
                  </template>
                  <template v-slot:body="{ items }">
                    <tr
                      class="tableBody"
                      v-for="(item, itemIndex) in items"
                      :key="itemIndex"
                       :class="{ 'selected-row': selectedItem === itemIndex }"
                    >
                      <td
                        @click="onRowClick(item,itemIndex)"
                        :class="{
                          'text-holiday': item.IsHoliday
                        }"
                      >
                        {{ item.Date }} ({{ getWeek(item.Date) }})
                      </td>
                      <td   @click="onRowClick(item,itemIndex)">{{ item.UserID }}</td>
                      <td   @click="onRowClick(item,itemIndex)">{{ item.UserName }}</td>
                      <td   @click="onRowClick(item,itemIndex)">{{ item.Description }}</td>
                      <td
                        @click="onRowClick(item,itemIndex)"
                        class="tdIn"
                        :class="{
                          'table-absent': item.Absent && item.ExpIn,
                          'table-late': item.LateToWork && item.ExpIn
                        }"
                      >
                        {{ item.ExpIn }}
                      </td>
                      <td
                        @click="onRowClick(item,itemIndex)"
                        class="tdIn"
                        :class="{
                          'table-absent': item.Absent && item.ExpIn,
                          'table-late': item.LateToWork && item.ExpIn
                        }"
                      >
                        {{
                          item.ActIn
                            ? moment(item.ActIn).format(Settings.DateTime.hhmm)
                            : "-"
                        }}
                        {{
                          moment(item.ActIn).format(
                            Settings.DateTime.yyyymmdd
                          ) > item.Date && item.ActIn
                            ? ` (${t.t(dictEnum.LBL_NextDay)})`
                            : ""
                        }}
                      </td>
                      <td
                        @click="onRowClick(item,itemIndex)"
                        class="tdIn ellipsis"
                        v-b-tooltip
                        :title="
                          item.Absent && item.ExpIn
                            ? t.t(dictEnum.LBL_Absent)
                            : item.InLoc
                        "
                        :class="{
                          'table-absent': item.Absent && item.ExpIn,
                          'table-late': item.LateToWork && item.ExpIn
                        }"
                      >
                        {{
                          item.Absent && item.ExpIn
                            ? t.t(dictEnum.LBL_Absent)
                            : item.InLoc
                        }}
                      </td>
                      <td
                        @click="onRowClick(item,itemIndex)"
                        class="tdIn"
                        :class="{
                          'table-absent': item.Absent && item.ExpOut,
                          'table-late': item.LateToWork && item.ExpOut
                        }"
                      >
                        {{ FromApp(item, item.InFromApp) }}
                      </td>
                      <td
                        @click="onRowClick(item,itemIndex)"
                        class="tdOut"
                        :class="{
                          'table-absent': item.Absent && item.ExpOut,
                          'table-late': item.EarlyLeave && item.ExpOut
                        }"
                      >
                        {{ item.ExpOut }}
                        {{
                          item.ExpIn > item.ExpOut
                            ? ` (${t.t(dictEnum.LBL_NextDay)})`
                            : ""
                        }}
                      </td>
                      <td
                        @click="onRowClick(item,itemIndex)"
                        class="tdOut"
                        :class="{
                          'table-absent': item.Absent && item.ExpOut,
                          'table-late': item.EarlyLeave && item.ExpOut
                        }"
                      >
                        {{
                          item.ActOut
                            ? moment(item.ActOut).format(Settings.DateTime.hhmm)
                            : "-"
                        }}
                        {{
                          moment(item.ActOut).format(
                            Settings.DateTime.yyyymmdd
                          ) > item.Date && item.ActOut
                            ? ` (${t.t(dictEnum.LBL_NextDay)})`
                            : ""
                        }}
                      </td>
                      <td
                        @click="onRowClick(item,itemIndex)"
                        class="tdOut ellipsis"
                        v-b-tooltip
                        :title="
                          item.Absent && item.ExpIn
                            ? t.t(dictEnum.LBL_Absent)
                            : item.OutLoc
                        "
                        :class="{
                          'table-absent': item.Absent && item.ExpOut,
                          'table-late': item.EarlyLeave && item.ExpOut
                        }"
                      >
                        {{
                          item.Absent && item.ExpIn
                            ? t.t(dictEnum.LBL_Absent)
                            : item.OutLoc
                        }}
                      </td>
                      <td
                        @click="onRowClick(item,itemIndex)"
                        class="tdOut"
                        :class="{
                          'table-absent': item.Absent && item.ExpOut,
                          'table-late': item.EarlyLeave && item.ExpOut
                        }"
                      >
                        {{ FromApp(item, item.OutFromApp) }}
                      </td>
                      <td class="text-right"   @click="onRowClick(item,itemIndex)">
                        <div v-if="WrkSplit">
                          {{ item.NormalWrkHrs | toFixedDecimal(2) }} (+{{
                            item.OTWrkHrs | toFixedDecimal(2)
                          }})
                        </div>
                        <div v-else>
                          {{ item.WrkHrs | toFixedDecimal(2) }}
                        </div>
                      </td>
                      <td
                        :class="{
                          'text-holiday': item.IsHoliday
                        }"
                        class="ellipsis"
                        v-b-tooltip
                        :title="item.HolidayDesc"
                      >
                        {{ item.HolidayDesc }}
                      </td>
                      <td>
                        <a
                          v-if="hasRight('AlwWrite')"
                          href="javascript:void(0);"
                          class="pl-2"
                          @click="updateRecord(item)"
                        >
                          <img
                            src="../../../static/images/edit-pen.png"
                            class="w-12"
                          />
                        </a>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
              <b-row
                style="position: absolute; bottom: 0px"
                no-gutters
                class="pt-3"
                v-if="activeTable.datas.length > 0"
              >
                <b-col cols="12">
                  <b-pagination
                    first-number
                    last-number
                    limit="10"
                    v-model="page"
                    :per-page="itemsPerPage"
                    :total-rows="activeTable.datas.length"
                  ></b-pagination>
                </b-col>
              </b-row>
            </div>
            <div v-else class="h-100">
              <div class="tab-pane active table-responsive color-table h-85">
                <v-data-table
                  disable-sort
                  :headers="cntTable.headers"
                  :items="cntTable.datas"
                  :page.sync="page"
                  :items-per-page="itemsPerPage"
                  hide-default-footer
                  class="elevation-1 tableRecord"
                  @page-count="pageCount = $event"
                >
                  <template v-slot:[`header.WorkHours`]="{ header }">
                    <div class="text-right">
                      {{ header.text }}
                    </div>
                  </template>
                  <template v-slot:body="{ items }">
                    <tr
                      class="tableBody"
                      v-for="(item, itemIndex) in items"
                      :key="itemIndex"
                    >
                      <td
                        :class="{
                          'text-holiday': item.IsHoliday
                        }"
                      >
                        {{ item.Date }} ({{ getWeek(item.Date) }})
                      </td>
                      <td>{{ item.UserName }}</td>
                      <td>{{ item.Description }}</td>
                      <td
                        class="tdIn"
                        :class="{
                          'table-absent': item.Absent && item.ExpIn,
                          'table-late': item.LateToWork && item.ExpIn
                        }"
                      >
                        {{ item.ExpIn }}
                      </td>
                      <td
                        class="tdIn"
                        :class="{
                          'table-absent': item.Absent && item.ExpIn,
                          'table-late': item.LateToWork && item.ExpIn
                        }"
                      >
                        {{
                          item.CntClockIn
                            ? moment(item.CntClockIn).format(
                                Settings.DateTime.hhmm
                              )
                            : "-"
                        }}
                        {{
                          moment(item.CntClockIn).format(
                            Settings.DateTime.yyyymmdd
                          ) > item.Date && item.CntClockIn
                            ? ` (${t.t(dictEnum.LBL_NextDay)})`
                            : ""
                        }}
                      </td>
                      <td
                        class="tdIn ellipsis"
                        v-b-tooltip
                        :title="
                          item.Absent && item.ExpIn
                            ? t.t(dictEnum.LBL_Absent)
                            : item.InLoc
                        "
                        :class="{
                          'table-absent': item.Absent && item.ExpIn,
                          'table-late': item.LateToWork && item.ExpIn
                        }"
                      >
                        {{
                          item.Absent && item.ExpIn
                            ? t.t(dictEnum.LBL_Absent)
                            : item.InLoc
                        }}
                      </td>
                      <td
                        class="tdIn"
                        :class="{
                          'table-absent': item.Absent && item.ExpOut,
                          'table-late': item.LateToWork && item.ExpOut
                        }"
                      >
                        {{ FromApp(item, item.InFromApp) }}
                      </td>
                      <td
                        class="tdOut"
                        :class="{
                          'table-absent': item.Absent && item.ExpOut,
                          'table-late': item.EarlyLeave && item.ExpOut
                        }"
                      >
                        {{ item.ExpOut }}
                        {{
                          item.ExpIn > item.ExpOut
                            ? ` (${t.t(dictEnum.LBL_NextDay)})`
                            : ""
                        }}
                      </td>
                      <td
                        class="tdOut"
                        :class="{
                          'table-absent': item.Absent && item.ExpOut,
                          'table-late': item.EarlyLeave && item.ExpOut
                        }"
                      >
                        {{
                          item.CntClockOut
                            ? moment(item.CntClockOut).format(
                                Settings.DateTime.hhmm
                              )
                            : "-"
                        }}
                        {{
                          moment(item.CntClockOut).format(
                            Settings.DateTime.yyyymmdd
                          ) > item.Date && item.CntClockOut
                            ? ` (${t.t(dictEnum.LBL_NextDay)})`
                            : ""
                        }}
                      </td>
                      <td
                        class="tdOut ellipsis"
                        v-b-tooltip
                        :title="
                          item.Absent && item.ExpIn
                            ? t.t(dictEnum.LBL_Absent)
                            : item.OutLoc
                        "
                        :class="{
                          'table-absent': item.Absent && item.ExpOut,
                          'table-late': item.EarlyLeave && item.ExpOut
                        }"
                      >
                        {{
                          item.Absent && item.ExpIn
                            ? t.t(dictEnum.LBL_Absent)
                            : item.OutLoc
                        }}
                      </td>
                      <td
                        class="tdOut"
                        :class="{
                          'table-absent': item.Absent && item.ExpOut,
                          'table-late': item.EarlyLeave && item.ExpOut
                        }"
                      >
                        {{ FromApp(item, item.OutFromApp) }}
                      </td>
                      <td class="text-right">
                        {{ item.WrkHrs }}
                      </td>
                      <td
                        class="ellipsis"
                        v-b-tooltip
                        :title="item.HolidayDesc"
                        :class="{
                          'text-holiday': item.IsHoliday
                        }"
                      >
                        {{ item.HolidayDesc }}
                      </td>
                      <td>
                        <a
                          v-if="hasRight('AlwWrite')"
                          href="javascript:void(0);"
                          class="pl-2"
                          @click="updateRecord(item)"
                        >
                          <img
                            src="../../../static/images/edit-pen.png"
                            class="w-12"
                          />
                        </a>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
              <b-row
                no-gutters
                class="pt-3"
                v-if="cntTable.datas.length > 0"
                style="position: absolute; bottom: 0px"
              >
                <b-col cols="12">
                  <b-pagination
                    first-number
                    last-number
                    limit="10"
                    v-model="page"
                    :per-page="itemsPerPage"
                    :total-rows="cntTable.datas.length"
                  ></b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- Staff Modal Start -->
    <div
      class="modal fade"
      id="staffModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="staffModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered mw-820" role="document">
        <div class="modal-content list-modal">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              {{ t.t(dictEnum.LBL_StaffList) }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-search">
            <form class="form-inline">
              <div class="form-group mx-sm-3 mb-2 mt-2">
                <label for="inputPassword2" class="sr-only">search</label>
                <input
                  type="text"
                  class="form-control"
                  id="inputPassword2"
                  v-model="searchValue"
                  :placeholder="t.t(dictEnum.LBL_SearchStaff)"
                />
              </div>
            </form>
          </div>
          <div class="modal-body p-0">
            <v-simple-table
              class="table table-sm mb-0 modal-tbl"
              min-height="500"
              height="500"
            >
              <template>
                <thead>
                  <tr>
                    <th width="15%">
                      {{ t.t(dictEnum.LBL_StaffID) }}
                    </th>
                    <th width="20%">
                      {{ t.t(dictEnum.LBL_UserChiname) }}
                    </th>
                    <th width="20%">
                      {{ t.t(dictEnum.LBL_EngName) }}
                    </th>
                    <th width="20%">
                      {{ t.t(dictEnum.LBL_Job) }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in StaffList"
                    v-on:click="OnStaffSelect(item)"
                    :key="index"
                  >
                    <td width="15%">{{ item.StaffID }}</td>
                    <td width="20%">
                      {{ `${item.ChiLastName}${item.ChiName}` }}
                    </td>
                    <td width="20%">
                      {{ `${item.EngName} ${item.EngLastName}` }}
                    </td>
                    <td width="20%">
                      {{ `${item.JobTitle}` }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </div>
      </div>
    </div>
    <!-- Staff Modal End -->
    <b-modal
      id="modal-attendanceShow"
      :title="t.t(dictEnum.BTN_Update)"
      :ok-title="t.t(dictEnum.BTN_Submit)"
      :cancel-title="t.t(dictEnum.BTN_Cancel)"
      @ok="updateStaffAttendance(selectedAttendance)"
      @cancel="cancelAttendance"
    >
      <div class="p-3">
        <b-row class="my-1 no-gutters pt-3">
          <b-col sm="4">
            <label class="inputs-lbl mb-1">
              {{ t.t(dictEnum.LBL_Date) }}
            </label>
          </b-col>
          <b-col sm="7">
            <date-picker
              :placeholder="this.t.t(dictEnum.LBL_Date)"
              v-model="selectedAttendance.Date"
              :date-format-options="{
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }"
              :lang="lang"
              :disabled="true"
              type="date"
              format="YYYY-MM-DD"
              v-bind:editable="true"
              v-bind:clearable="false"
            ></date-picker>
          </b-col>
        </b-row>

        <b-row class="my-1 no-gutters pt-3">
          <b-col sm="4">
            <label class="inputs-lbl mb-1">
              {{ t.t(dictEnum.LBL_Username) }}
            </label>
          </b-col>
          <b-col sm="7">
            <b-form-input
              disabled
              v-model="selectedAttendance.UserName"
            ></b-form-input>
          </b-col>
        </b-row>

        <b-row class="my-1 no-gutters pt-3">
          <b-col sm="4">
            <label class="inputs-lbl mb-1">
              {{ t.t(dictEnum.LBL_Description) }}
            </label>
          </b-col>
          <b-col sm="7">
            <b-form-input
              disabled
              v-model="selectedAttendance.Description"
            ></b-form-input>
          </b-col>
        </b-row>

        <b-row class="my-1 no-gutters pt-3">
          <b-col sm="4">
            <label class="inputs-lbl mb-1">
              {{ t.t(dictEnum.LBL_ExpectedInAbbr) }}
            </label>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                disabled
                v-model="selectedAttendance.ExpIn"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="my-1 no-gutters pt-3">
          <b-col sm="4">{{ t.t(dictEnum.LBL_ActInAbbr) }} </b-col>
          <b-col sm="7">
            <date-picker
              :disabled-days="
                date =>
                  date >
                    new Date(
                      moment(selectedAttendance.Date)
                        .add(1, 'days')
                        .format(Settings.DateTime.yyyymmdd)
                    ) ||
                  date <
                    new Date(
                      moment(selectedAttendance.Date)
                        .add(-2, 'days')
                        .format(Settings.DateTime.yyyymmdd)
                    )
              "
              :placeholder="this.t.t(dictEnum.LBL_ActInAbbr)"
              v-model="selectedAttendance.ActIn"
              :lang="lang"
              type="datetime"
              :format="Settings.DateTime.yyyymmddhhmm"
              v-bind:editable="true"
              v-bind:clearable="false"
            ></date-picker>
          </b-col>
        </b-row>

        <b-row class="my-1 no-gutters pt-3">
          <b-col sm="4">{{ t.t(dictEnum.LBL_InLoc) }} </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                disabled
                v-model="selectedAttendance.InLoc"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="my-1 no-gutters pt-3">
          <b-col sm="4">{{ t.t(dictEnum.LBL_IsFromApp) }} </b-col>
          <b-col sm="7">
            <b-form-checkbox disabled v-model="selectedAttendance.InFromApp">
            </b-form-checkbox>
          </b-col>
        </b-row>

        <b-row class="my-1 no-gutters pt-3">
          <b-col sm="4">{{ t.t(dictEnum.LBL_ExpectedOutAbbr) }} </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                disabled
                v-model="selectedAttendance.ExpOut"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="my-1 no-gutters pt-3">
          <b-col sm="4">{{ t.t(dictEnum.LBL_ActOutAbbr) }} </b-col>
          <b-col sm="7">
            <date-picker
              :disabled-days="
                date =>
                  date >
                    new Date(
                      moment(selectedAttendance.Date)
                        .add(1, 'days')
                        .format(Settings.DateTime.yyyymmdd)
                    ) ||
                  date <
                    new Date(
                      moment(selectedAttendance.Date)
                        .add(-2, 'days')
                        .format(Settings.DateTime.yyyymmdd)
                    )
              "
              :placeholder="this.t.t(dictEnum.LBL_ActOutAbbr)"
              v-model="selectedAttendance.ActOut"
              :lang="lang"
              type="datetime"
              :format="Settings.DateTime.yyyymmddhhmm"
              v-bind:editable="true"
              v-bind:clearable="false"
            ></date-picker>
          </b-col>
        </b-row>

        <b-row class="my-1 no-gutters pt-3">
          <b-col sm="4">{{ t.t(dictEnum.LBL_OutLoc) }} </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                disabled
                v-model="selectedAttendance.OutLoc"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="my-1 no-gutters pt-3">
          <b-col sm="4">{{ t.t(dictEnum.LBL_IsFromApp) }} </b-col>
          <b-col sm="7">
            <b-form-checkbox disabled v-model="selectedAttendance.OutFromApp">
            </b-form-checkbox>
          </b-col>
        </b-row>
      </div>
    </b-modal>
      <!-- select Modal Start -->
      <div
      class="modal fade"
      id="SelectUserModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="SelectUserModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered mw-820" role="document">
        <div class="modal-content list-modal">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              {{ t.t(dictEnum.MENU_StaffAttendance) }} 
              <span style="margin-left: 30px;">{{ selectStaffTrace.UserID }}</span>
              <span style="margin-left: 30px;">{{ `${selectStaffTrace.UserName}` }}</span>
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body p-0">
            <v-simple-table
              class="table table-sm mb-0 modal-tbl"
              min-height="500"
              height="500"
            >
              <template>
                <thead>
                  <tr>
                    <th width="15%">
                      {{ t.t(dictEnum.LBL_Time) }}
                    </th>
                    <th width="35%">
                      {{ t.t(dictEnum.LBL_Address) }}
                    </th>
                    <th width="15%">
                      {{ t.t(dictEnum.LBL_PunchingMethod) }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in StaffTraceList"
                    :key="index"
                  >
                  <td
                     width="15%"
                      >
                        {{
                          item.DateTimeCard
                            ? moment(item.DateTimeCard).format("YYYY-MM-DD HH:mm:ss")
                            : "-"
                        }}
                      </td>
                      <td
                       width="35%"
                      >
                        {{
                          !item.Loc
                            ? t.t(dictEnum.LBL_Absent)
                            : item.NFC==true?'(N)'+item.Loc:'(G)'+item.Loc
                        }}
                      </td>
                      <td
                       width="15%"
                      >
                        {{ item.IsFromApp==true ? t.t(dictEnum.LBL_IsFromApp2) : t.t(dictEnum.LBL_TakeCard) }}
                      </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import moment from "moment";
import JsonExcel from "vue-json-excel";
import FileReader from "@/components/FileReader";
import MenuRightSerivce from "@/service/MenuRightService";
import ReportService from "@/service/ReportService";
import $t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import TimecardService from "@/service/TimecardService";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import S040000Menu from "@/components/S040000-Report/S040000-Menu.vue";
import { datePickerLang } from "@/constants/globalConstants";
import AttendanceImport from "@/service/AttendanceImport";
import Settings from "../../constants/Settings";
import StaffService from "../../service/StaffService";
import ArrayHelper from "../../common/helper/ArrayHelper";

export default {
  components: {
    DatePicker,
    moment,
    S040000Menu,
    JsonExcel,
    FileReader
  },
  data() {
    return {
      selectStaffTrace:[],
      StaffTraceList:[],//当前选中用户的打卡记录
      selectedItem:null,//选中行
      menuRights: { allRights: {}, rightsForThisMenu: {} },
      t: $t,
      moment: moment,
      menuId: Settings.MenuID.StaffAttendance,
      Settings: Settings,
      staffList: [],
      exportdata: {},
      columnsexport: {
        Date: "Date",
        CardID: "CardID",
        UserName: "UserName",
        Description: "Description",
        ExpIn: "ExpIn",
        ActIn: "ActIn",
        InLoc: "InLoc",
        InFromApp: "InFromApp",
        ExpOut: "ExpOut",
        ActOut: "ActOut",
        OutLoc: "OutLoc",
        OutFromApp: "OutFromApp",
        WorkHours: "WorkHours",
        HolidayDesc: "HolidayDesc"
      },
      dictEnum: dictEnum,
      DateFrom: moment()
        .startOf("month")
        .toDate(),
      DateTo: moment()
        .endOf("month")
        .toDate(),
      // custom lang
      moment: moment,
      lang: datePickerLang,
      searchValue: "",
      selectedStaff: "",
      selectedUserID: "",
      page: 1,
      pageCount: 0,
      itemsPerPage: 15,
      selectedAttendance: {},
      activeTable: {
        headers: [
          {
            value: "Date",
            text: $t.t(dictEnum.LBL_Date),
            width: "7%"
          },
          {
            value: "UserID",
            text: $t.t(dictEnum.LBL_StaffID),
            width: "8%"
          },
          {
            value: "UserID",
            text: $t.t(dictEnum.LBL_Username),
            width: "8%"
          },
          {
            value: "Description",
            text: $t.t(dictEnum.LBL_Description),
            width: "9%"
          },
          {
            value: "ExpIn",
            text: $t.t(dictEnum.LBL_ExpectedInAbbr),
            width: "5%"
          },
          {
            value: "ActIn",
            text: $t.t(dictEnum.LBL_ActInAbbr),
            width: "5%"
          },
          {
            value: "InLoc",
            text: $t.t(dictEnum.LBL_InLoc),
            width: "10%"
          },
          {
            value: "InFromApp",
            text: $t.t(dictEnum.LBL_IsFromApp),
            width: "4%"
          },
          {
            value: "ExpOut",
            text: $t.t(dictEnum.LBL_ExpectedOutAbbr),
            width: "5%"
          },
          {
            value: "ActOut",
            text: $t.t(dictEnum.LBL_ActOutAbbr),
            width: "5%"
          },
          {
            value: "OutLoc",
            text: $t.t(dictEnum.LBL_OutLoc),
            width: "10%"
          },
          {
            value: "OutFromApp",
            text: $t.t(dictEnum.LBL_IsFromApp),
            width: "4%"
          },
          {
            value: "WorkHours",
            text: $t.t(dictEnum.LBL_WorkHrs),
            width: "4%"
          },
          {
            value: "HolidayDesc",
            text: $t.t(dictEnum.MENU_Holiday),
            width: "5%"
          },
          {
            value: "Action",
            text: "",
            width: "2%"
          }
        ],
        datas: []
      },
      cntTable: {
        headers: [
          {
            value: "Date",
            text: $t.t(dictEnum.LBL_Date),
            width: "7%"
          },
          {
            value: "UserID",
            text: $t.t(dictEnum.LBL_Username),
            width: "8%"
          },
          {
            value: "Description",
            text: $t.t(dictEnum.LBL_Description),
            width: "9%"
          },
          {
            value: "ExpIn",
            text: $t.t(dictEnum.LBL_ExpectedInAbbr),
            width: "5%"
          },
          {
            value: "CntIn",
            text: $t.t(dictEnum.LBL_CntClockIn),
            width: "5%"
          },
          {
            value: "InLoc",
            text: $t.t(dictEnum.LBL_InLoc),
            width: "10%"
          },
          {
            value: "InFromApp",
            text: $t.t(dictEnum.LBL_IsFromApp),
            width: "4%"
          },
          {
            value: "ExpOut",
            text: $t.t(dictEnum.LBL_ExpectedOutAbbr),
            width: "5%"
          },
          {
            value: "CntOut",
            text: $t.t(dictEnum.LBL_CntClockOut),
            width: "5%"
          },
          {
            value: "OutLoc",
            text: $t.t(dictEnum.LBL_OutLoc),
            width: "10%"
          },
          {
            value: "OutFromApp",
            text: $t.t(dictEnum.LBL_IsFromApp),
            width: "4%"
          },
          {
            value: "WorkHours",
            text: $t.t(dictEnum.LBL_WorkHrs),
            width: "4%"
          },
          {
            value: "HolidayDesc",
            text: $t.t(dictEnum.MENU_Holiday),
            width: "5%"
          },
          {
            value: "Action",
            text: "",
            width: "2%"
          }
        ],
        datas: []
      },
      switchMode: true,
      compList: [],
      selectedComp: "",
      CompanyHide:false
    };
  },
  computed: {
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    userName() {
      return this.$store.getters[StoreGetter.user].Lang == "EN"
        ? this.$store.getters[StoreGetter.user].EngName
        : this.$store.getters[StoreGetter.user].ChiName;
    },
    StaffList() {
      let list = this.staffList;
      if (this.selectedComp) {
        list = list.filter(x => x.CompCode == this.selectedComp);
      }
      if (this.searchValue != "") {
        list = list.filter(x =>
          ArrayHelper.staffSearch(x, this.searchValue.toLowerCase())
        );
      }
      return list;
    },
    AttendanceTable() {
      const bol = this.switchMode;
      return bol ? this.activeTable : this.cntTable;
    },
    WrkSplit() {
      const sysParams = this.$store.getters[StoreGetter.sysParams];
      let WrkHrsSplit = false;
      const find = sysParams.find(
        x => x.ParamCode == Settings.SysParams.WorkHoursSplit
      );
      if (find) {
        WrkHrsSplit = find.ParamVal.toLowerCase() === "true";
      }
      return WrkHrsSplit;
    }
  },
  methods: {
    setCompanyHide(){
    let user=this.$store.getters[StoreGetter.user].UserGrps;
    let sysParams = this.$store.getters[StoreGetter.sysParams];
    //定义需要查找的 ParamCode 值
    const paramCodes = ['HRADMIN', 'HRDEPT', 'ADMIN'];
    let combinedArray = [];
    paramCodes.forEach(paramCode => {
      let item = sysParams.find(item => item.ParamCode === paramCode);
      if (item && item.ParamVal) {
        combinedArray = combinedArray.concat(item.ParamVal.split(','));
      }
    });
    let uniqueArray = [...new Set(combinedArray)];
    // 判断 uniqueArray 中是否有与 user 中一致的数据
    this.CompanyHide = uniqueArray.some(value => user.includes(value));
    },
    handleResize() {
      this.getPerPage();
      // const windowHeight = window.innerHeight;
      // // 根据窗口高度计算合适的 itemsPerPage 值
      // // 这里假设每行高度为 50px，表头高度为 60px，底部工具栏高度为 50px
      // const rowHeight = 50;
      // const headerHeight = 60;
      // const footerHeight = 50;
      // const availableHeight = windowHeight - headerHeight - footerHeight;
      // this.itemsPerPage = Math.floor(availableHeight / rowHeight);
    },
    async onRowClick(item,itemIndex){
      console.log(item,'选中行数据');
      this.selectStaffTrace=item;
      this.selectedItem = itemIndex; // 更新选中的行索引
      $("#SelectUserModal").modal("show");
      //获取选中行的数据
      const obj = {
        staffID: item.UserID,
        dateTrace:item.Date
        // dateTrace:"2023-06-29"
      };
      const response = await StaffService.getStaffTrace(obj);
      if (response.data.IsSuccess) {
        this.StaffTraceList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    getMsg(key) {
      return $msg.getValue(this.dict, key);
    },
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },

    assignRights() {
      this.menuRights.allRights = this.menuRights.allRights = this.$store.getters[
        StoreGetter.sysMenu
      ];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    OnStaffBtnClick: function() {
      $("#staffModal").modal("show");
    },
    OnStaffSelect: function(model) {
      var self = this;
      if (self.$store.getters[StoreGetter.user].Lang == "EN") {
        self.selectedStaff = model["EngName"] + " " + model["EngLastName"];
      } else {
        self.selectedStaff = model["ChiLastName"] + model["ChiName"];
      }
      self.selectedUserID = model["StaffID"];
      $("#staffModal").modal("hide");
    },

    // 汇入打卡记录
    async importData(value) {
      console.log("importData", value);
      const compCode = this.$store.state.AuthenticationStore.user.CompCode;
      if (compCode == Settings.CompCode.Eisai) {
        AttendanceImport.esia(value);
      } else if (compCode == Settings.CompCode.ECINFO) {
        AttendanceImport.ecinfo();
      } else if (compCode == Settings.CompCode.ESSILOR) {
        AttendanceImport.essilor();
      } else if (compCode == Settings.CompCode.BEX) {
        AttendanceImport.BEX();
      } else if (compCode == Settings.CompCode.DMC) {
        AttendanceImport.DMC();
      } else if (compCode == Settings.CompCode.SAILINGBOAT) {
        AttendanceImport.sailingBoat();
      } else if (compCode == "ECINFOT") {
        AttendanceImport.ecinfo();
      } else {
        AttendanceImport.test(value);
      }
    },

    // 汇入Excel记录
    async importExcelData(value) {
      console.log("importExcelData", value);
      console.log(compCode == Settings.CompCode.SAILINGBOAT);
      const compCode = this.$store.state.AuthenticationStore.user.CompCode;
      if (compCode == Settings.CompCode.SAILINGBOAT) {
        AttendanceImport.sailingBoatExcel("excelFileReader");
      } else {
        AttendanceImport.test(value, "excelFileReader");
      }
    },

    async getPerPage() {
      const tableEle = await document.getElementsByClassName("tab-pane");
      const tableBody = await document.getElementsByClassName("tableBody");
      const tableHead = await document.getElementsByClassName(
        "v-data-table-header"
      );
      const tableHeight = tableEle[0].offsetHeight;
      const bodyHeight = 35;
      const headHeight = tableHead[0].offsetHeight;
      let page = (tableHeight - headHeight * 2) / bodyHeight;
      page = Number(page.toFixed(0));
      this.itemsPerPage = page<=15?page+1:page;
    },

    async getCompanyList() {
      const obj = {};
      const response = await StaffService.getAllCompany(obj);
      if (response.data.IsSuccess) {
        this.compList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getStaffList() {
      const obj = {
        staffID: this.user.UserID,
        dateFrom: moment(this.DateFrom)
          .startOf("month")
          .format(Settings.DateTime.yyyymmdd),
        dateTo: moment(this.DateTo)
          .endOf("month")
          .format(Settings.DateTime.yyyymmdd)
      };
      const response = await StaffService.getStaffListOnDuty(obj);
      if (response.data.IsSuccess) {
        this.staffList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    updateRecord(item) {
      this.selectedAttendance = JSON.parse(JSON.stringify(item));
      this.$bvModal.show("modal-attendanceShow");
    },

    cancelAttendance() {
      this.$bvModal.hide("modal-attendanceShow");
    },

    async updateStaffAttendance(record) {
      let ActIn = moment(record.ActIn).format(
        Settings.DateTime.yyyymmddhhmmssa
      );
      let ActOut = moment(record.ActOut).format(
        Settings.DateTime.yyyymmddhhmmssa
      );
      if (!record.ActIn) {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.LBL_ActInAbbr) + this.t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }
      if (!record.ActOut) {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.LBL_ActOutAbbr) + this.t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }
      const obj = {
        model: {
          UserID: record.UserID,
          DateTimeCard: record.Date,
          Seq: 0,
          ClockIn: moment(ActIn, Settings.DateTime.yyyymmddhhmmss).format(
            Settings.DateTime.yyyymmddhhmmss
          ),
          ClockOut: moment(ActOut, Settings.DateTime.yyyymmddhhmmss).format(
            Settings.DateTime.yyyymmddhhmmss
          ),
          CntClockIn: moment(ActIn, Settings.DateTime.yyyymmddhhmmss).format(
            Settings.DateTime.yyyymmddhhmmss
          ),
          CntClockOut: moment(ActOut, Settings.DateTime.yyyymmddhhmmss).format(
            Settings.DateTime.yyyymmddhhmmss
          ),
          ClockInLoc: record.InLoc,
          ClockOutLoc: record.OutLoc,
          IsFromAppIn: record.InFromApp,
          IsFromAppOut: record.OutFromApp
        }
      };

      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: `${$t.t(dictEnum.MSG_UpdateAttendance)}`,
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        const response = await ReportService.updateStaffAttendance(obj);
        if (response.data.IsSuccess) {
          this.search();
          SweetAlertService.success("Success", response.data.Message);
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      }
    },

    async ExportTableData() {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: this.t.t(dictEnum.MSG_ExportFile),
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        const staffMap = new Map(
          this.staffList.map(staff => [staff.StaffID, staff])
        );
        return this.activeTable.datas.map(data => {
          return {
            ...data,
            CardID: staffMap.has(data.UserID)
              ? staffMap.get(data.UserID).BadgeNum
              : ""
          };
        });
      }
    },

    changeComp() {
      this.selectedStaff = "";
      this.selectedUserID = "";
    },

    async search() {
      //inclSubordinate can show all staff record
      const obj = {
        userId: this.selectedStaff ? this.selectedUserID : this.user.UserID,
        dateStart: moment(this.DateFrom).format(Settings.DateTime.yyyymmdd),
        dateEnd: moment(this.DateTo).format(Settings.DateTime.yyyymmdd),
        inclSubordinate: this.selectedStaff ? 0 : 1,
        compCode: this.selectedComp
      };

      const response = await ReportService.getStaffAttendance(obj);
      if (response.data.IsSuccess) {
        response.data.Data = ArrayHelper.sortByKey(response.data.Data, "Date");
        const data = response.data.Data;
        this.activeTable.datas = data;
        this.exportdata = data;
        this.getPerPage();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async syncFromMizar() {
      var DateFrom = moment(this.DateFrom).format(Settings.DateTime.yyyymmdd);
      var DateTo = moment(this.DateTo).format(Settings.DateTime.yyyymmdd);
      const obj = {
        DateFrom: DateFrom,
        DateTo: DateTo
      };
      const response = await TimecardService.syncAttendance(obj);
      if (response.data.IsSuccess) {
        this.search();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async updateTimeCard() {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: this.t.t(dictEnum.MSG_AreSureUpdateTimeCard),
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        const staffIDs = this.staffList.map(x => x.StaffID);
        const obj = {
          staffID: staffIDs,
          dateFrom: moment(this.DateFrom).format(Settings.DateTime.yyyymmdd),
          dateTo: moment(this.DateTo).format(Settings.DateTime.yyyymmdd)
        };
        const response = await TimecardService.updateTimeCard(obj);
        if (response.data.IsSuccess) {
          SweetAlertService.success("Success", response.data.Message);
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      }
    },

    changeMode() {
      this.page = 1;
      if (this.switchMode) {
      } else {
      }
    },

    getWeek(date) {
      let week = moment(date).day();
      const weekList = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"];
      const weekValue = weekList[week];
      return weekValue;
    },

    FromApp(item, isFromApp) {
      if (item.IsHoliday || item.Absent) {
        return "-";
      } else {
        return isFromApp ? "Y" : "N";
      }
    }
  },

  mounted() {
    this.setCompanyHide();
    this.assignRights();
    this.getStaffList();
    this.getCompanyList();
    window.addEventListener('resize', this.handleResize);
    this.handleResize(); // 初始化时调用一次
  }
};
</script>
<style scoped lang="scss">
.switchChk {
  >>> .custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    border-color: #04a2b3 !important;
    background-color: #04a2b3 !important;
  }
}
.mx-calendar-icon {
  width: 100%;
  height: auto !important;
  color: #555;
  stroke-width: 8px;
  stroke: currentColor;
  fill: currentColor;
}
.selected-row {
  // background-color: #b4ccea !important;/* 选中行的背景颜色 */
  // z-index:666;
}
.table_space th {
  width: 20%;
}

.tableRecord {
  >>> table {
    table-layout: fixed;
  }

  .ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  min-height: 158px !important;
}

.tdIn {
  background-color: #e7f0ff;
}

.tdOut {
  background-color: #edf8ff;
}

.table-late {
  height: 100%;
  background-color: #ffd1b0;
}
.table-absent {
  color: white !important;
  background-color: #ee6766;
}

.text-holiday {
  color: #f14545 !important;
}
.btn-scroll {
  white-space: nowrap;
  width: 100%;
  box-sizing: border-box;
  overflow-x: auto;
}
.col2-width{
  flex: 0 0  15.6666666667% !important;
  max-width: 15.6666666667% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/S040000-Report/S040200-StaffAttendance.vue